import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import mitt from "mitt";
import { WEB_SOCKET_URI } from "./constants";

const app = createApp(App);
app.use(Quasar, quasarUserOptions).use(router).mount("#app");

app.provide("socket", new WebSocket(WEB_SOCKET_URI));

export const emitter = mitt();

export const BASE_PATH = "https://cycles.nlf.clinic/ws-nlp/public/pt-service";
